<div class="loading-shade" *ngIf="isLoading ">
	<mat-spinner diameter="80" *ngIf="isLoading"></mat-spinner>
</div>

<form [formGroup]="createSchoolsForm" class="formEditSchool" >
		<div *ngIf="!isCreated">
		<span class="forceFloatRight"><button mat-icon-button color="primary" (click)="closeRecord()">
				<span class="centercloseBtn"><mat-icon>close</mat-icon></span> 
			</button></span> 
		<mat-card-title><span style="padding-left:18px;padding-top:5px;font-size:larger;">Create New School </span></mat-card-title>
				<ng-container *ngIf="bCancelCreate"><button mat-raised-button matTooltip="Cancel create"
					(click)="fnCancelCreate()" class="btnRaise"><mat-icon class="iconDisplay">close
					</mat-icon></button></ng-container>

				<div class="row">
					<div class="child-1 col-6 halfWidth">
						<mat-card appearance="outlined" class="cardLocation">
							<mat-card-content>
								<h2>School Location</h2>
								<div class="form-group">
									<div class="row">
										
										<region-dropdown-two-way id="myRegion" [(selectedRegions)]="chosenRegions" (selectedRegionsChange)="regionEventEmitter($event)" [reset]="resetField"
											[isMultiple]="false" [customLabel]="customLabelRegion" [allowAllRegions]="true" #child2></region-dropdown-two-way>
											
										<county-dropdown-two-way id="myCounty1" [reset]="resetField" [(selectedCounties)]="chosenCounties" [regions]="chosenRegions" (selectedCountiesChange)="countiesSelected($event)"
											[isMultiple]="false" [customLabel]="customLabelCounty" #child3></county-dropdown-two-way>
											
										<district-dropdown-two-way id="myDistrict" [reset]="resetField" [(selectedSchoolDistricts)]="chosenSchoolDistricts" [counties]="chosenCounties" [regions]="chosenRegions" (selectedSchoolDistrictsChange)="districtsSelected($event)"
											[isMultiple]="false" [customLabel]="customLabelDistrict" #child></district-dropdown-two-way>
											
									</div>
							
									<div class="row">					
										<mat-form-field appearance="fill">
											<mat-label>School District NCES *</mat-label>
											<input id="schoolDistrictNCES" 	 	
												name="schoolDistrictNcesFC"
												ngDefaultControl					 	
												[formControl]="schoolDistrictNcesFC"
												type="tel" 
												matInput	 									
												class="form-control" 
												style="background-color:transparent;"
												minlength="7" maxlength="7" 											
												(keyup)="onKeyUp($event)"
												(keydown)="onKeyDown($event)" 
												(click)="fnDeactivateInitialLoad()" 									
												(paste)="onPasteNCESCode($event)"
												placeholder="NCES"
												[errorStateMatcher]="matcher"
												[(ngModel)]="schoolDistrictNCES"
												>  <!-- #child4-->
												<span class="checkCodeButton">
												<ng-container *ngIf="ncesChecking"> 
													<!-- !ncesValid   && !ncesChecked including if sc is blank or invalid-->
													<button class="btnCheckRed" mat-raised-button
														(click)="btnClick.emit($event)" style="transform: translateX(11px);">
														<i class="fa fa-refresh fa-spin fa-fw"></i>
													</button>
												</ng-container>

												<ng-container *ngIf="!ncesValid && !ncesChecking  && !ncesChecked">
													<button class="btnCheckRed" mat-raised-button
														(click)="btnClick.emit($event)">
														<mat-icon matSuffix>highlight_off</mat-icon>
													</button>
												</ng-container>
												<ng-container *ngIf="ncesValid && !ncesChecking">
													<button class="btnCheckGreen" mat-raised-button 
														(click)="btnClick.emit($event)">
														<mat-icon class="whiteIcon" matSuffix>check_circle</mat-icon>
													</button>
												</ng-container>
											</span>								
										</mat-form-field> 								
									</div>
								</div>
							</mat-card-content>
						</mat-card>
						<br>
						<mat-card appearance="outlined">
							<mat-card-content>			
								<h2>School</h2>
							
								<div class="form-group">
									<mat-card appearance="outlined">
										<mat-card-content>
											School Type *
											<div class="row">
												<div class="col-6"><!-- -->
												<!--	<mat-radio-group aria-label="Select an option"
													class="form-control" 
													aria-label="Select an option"	
													>
														<mat-radio-button *ngFor="let op of radioOptionsSchoolType" name="opList" 
														(click)="fnFigureRadioSchoolChecked($event, op.id, schoolType)"
														[checked]="((op.id == '1') && bCheckedSCCode1) || ((op.id == '2') && bCheckedSCCode2) || ((op.id == '3') && bCheckedSCCode3)"												
														value="op.id">Option 1</mat-radio-button>

													  </mat-radio-group> 
													-->
													<mat-radio-group name="radioSchoolTypeList" id="radioSchoolType"
														class="form-control" 																				
														[formControl]="radioSchoolTypeFC"				
														aria-label="Select an option">
														<mat-radio-button *ngFor="let op of radioOptionsSchoolType" name="opList"										
															[checked]="((op.id == '1') && bCheckedSCCode1) || ((op.id == '2') && bCheckedSCCode2) || ((op.id == '3') && bCheckedSCCode3)"
															(click)="fnFigureRadioSchoolChecked($event, op.id, schoolType)"
															value="op.id">{{ op.name}}
														</mat-radio-button>	&emsp;										
													</mat-radio-group>				
												</div>	
												<span class="lowerSubType">
												<mat-form-field appearance="fill">
														<mat-label>- Choose Other Sub-type -</mat-label>														
														<mat-select id="selectSubType" name="selectSubTypeFC" ngDefaultControl [(ngModel)]="selectedSubTypeItem" value="selectedSubTypeItem"
															[disabled]="bDisAllowSubTypes" formControlName="selectSubType"
															(ngModelChange)="showValuePromptText('SubTypeItem', $event)"
															[errorStateMatcher]="matcher" >
															<mat-option *ngFor="let subTypeItem of subTypeItems"
																[value]="subTypeItem?.ID">{{subTypeItem?.TYPE}}</mat-option>

														</mat-select>
														<!--  <mat-error *ngIf="selected.hasError('required')">You must make a
															selection
														</mat-error>
														<mat-error
															*ngIf="selected.hasError('pattern') && !selected.hasError('required')">
															Your selection is invalid
														</mat-error>-->
														<mat-error *ngIf="selected.hasError('blank')">Sub-type is required when Other is selected.
														</mat-error>

													</mat-form-field>
												</span>
												<!-- <p>&nbsp;</p> -->
												<div class="row">
													<mat-label>School Code *</mat-label>
												</div>
												<div class="row">
													<!-- ($event)" scValid {{scValid}} : ngChecking {{ngChecking}} : ngValid {{ngValid}} : ngChecked {{ngChecked}}   -->
													<mat-form-field appearance="fill">
														<input id="txtSchoolCode" type="text"
															(click)="btnClick2.emit($event)" 																														
															[formControl]="txtSchoolCodeFC"		
															name="txtSchoolCode"																																						
															maxlength="7"															
															(keydown)="onKeyDown($event)" 
															(keyup)="onKeyUp($event)"
															ngDefaultControl 																														
															(paste)="onPasteSchoolCode($event)"
															[readonly]="(!bAllowSC)"	
															[(ngModel)]="schoolCode"
															[disabled]="(!bAllowSC)"															
															matInput 		
															[errorStateMatcher]="matcher"
													 ><!--  	 pattern="[0-9]" -->
													<mat-error class="moveErrorsUp"
														*ngIf="!isInitialLoad && txtSchoolCodeFC.hasError('text')">
														Please enter a valid school code
													</mat-error>
													<mat-error class="moveErrorsUp"
														*ngIf="!isInitialLoad && txtSchoolCodeFC.hasError('maxlength')">
														School Code is 7 characters long.
													</mat-error>		
													<mat-error class="moveErrorsUp2"><!-- *ngIf="!isInitialLoad && bCustomSchoolCodeError"-->
														{{strCustomSchoolCodeError}}
													</mat-error>		
														<span class="checkCodeButton" > <!--style="position:absolute;right:35px;top:-22px;height:52px;width:20px;"-->
															<ng-container *ngIf="!scValid && ngChecking">																
																<!-- including if sc is blank or invalid-->
																<button class="btnCheckRed" mat-raised-button
																	(click)="btnClick.emit($event)" style="transform: translateX(11px);">
																	<i class="fa fa-refresh fa-spin fa-fw"></i>
																</button>
															</ng-container>
														<!--	<ng-container *ngIf="!scValid && !ngChecking && ngValid && !ngChecked">
																<button class="btnCheckRed" mat-raised-button
																	(click)="btnClick.emit($event)">
																	<i class="fa fa-check fa-fw" style="opacity:0.3"></i>
																	<mat-icon matSuffix>highlight_off</mat-icon>
																</button>
															</ng-container> 
															<ng-container *ngIf="!scValid && !ngChecking && ngValid && ngChecked">
																<button class="btnCheckRed" mat-raised-button
																	(click)="btnClick.emit($event)">
																	<i class="fa fa-check fa-fw"></i>
																	<mat-icon matSuffix>highlight_off</mat-icon>
																</button>
															</ng-container> -->
															<ng-container *ngIf="!scValid && !ngChecking && !ngValid && ngChecked">
																<button class="btnCheckRed" mat-raised-button
																	(click)="btnClick.emit($event)">
																	<mat-icon matSuffix>highlight_off</mat-icon>
																</button>
															</ng-container>

															<ng-container *ngIf="!scValid && !ngChecking && !ngValid && !ngChecked">
																<button class="btnCheckRed" mat-raised-button
																	(click)="btnClick.emit($event)">
																	<mat-icon matSuffix>highlight_off</mat-icon>
																</button>
															</ng-container>
															<ng-container *ngIf="scValid">
																<button class="btnCheckGreen" mat-raised-button
																	(click)="btnClick.emit($event)">
																	<mat-icon class="whiteIcon" matSuffix>check_circle</mat-icon>
																</button>
															</ng-container>
														</span>				
													</mat-form-field>
													<span class="raiseUpSmallErrorLabels">
														<mat-error *ngIf="selected.hasError('required')">Please enter a valid School
															Code.
														</mat-error>
													</span>
													<mat-error *ngIf="selected.hasError('blank')">School code is required when Public or Private is selected.
													</mat-error>
												</div>
											</div>
										</mat-card-content>
									</mat-card>							
								</div>
								<br>
								<div class="form-group">
									<div class="row">
										<mat-label>School Name *</mat-label>
									</div>
									<div class="row">
										<mat-form-field class="field-full-width" appearance="fill" tabindex="0">
											<input id="schoolName" type="text" 														
												(click)="fnDeactivateInitialLoad()"
												[formControl]="schoolNameFC"
												name="schoolNameFC"																																
												maxlength="100" 												 
												ngDefaultControl
												[(ngModel)]="schoolName" 																							
												matInput 
												
												class="form-control"
												[errorStateMatcher]="matcher" 
												placeholder="School Name"
												><!-- pattern="[A-Za-z]"-->																					
										</mat-form-field>
									</div>
									<div class="row">
										<mat-label>School NCES
											<help-text-btn class="align-help-text-btn" [helpTextId]="'SchoolNCES'"></help-text-btn>
										</mat-label>
									</div>
									<div class="row">
										<mat-form-field appearance="fill">
											<input id="txtSchoolNCES" type="text"
												(click)="btnClick2.emit($event)" 	
												[formControl]="txtSchoolNcesFC"		
												name="txtSchoolNcesFC"
												maxlength="5" 	
												(keydown)="onKeyDown($event)" 
												(keyup)="onKeyUp($event)"																																						
												ngDefaultControl																																			
												[(ngModel)]="schoolNCES"												
												matInput
												[errorStateMatcher]="matcher" 
												><!-- (paste)="onPasteNCESCode($event)"  class="field-full-width"  tabindex="3" (click)="fnDeactivateInitialLoad()" pattern="[0-9]"  class="form-control" 	
												-->
												<mat-error class="moveErrorsUp"
														*ngIf="!isInitialLoad && txtSchoolNcesFC.hasError('maxlength')">
														School NCES is 7 characters long.
													</mat-error>		
										
										</mat-form-field>
													
									</div>
								</div>																
							</mat-card-content>
						</mat-card>

						<div class="child-3 col-6">
							<br>							
							<mat-card appearance="outlined" class="cardSchoolStatus">
								<mat-card-content>
									<H2>School Status *</H2>
								<!-- 	school status {{schoolStatus}}
									{{(bCheckedSCCode1)}}
									{{(bCheckedSCCode2)}}
									{{(bCheckedSCCode3)}}  formControlName="radioSchoolStatus1"  -->
									<div class="form-group"> 
										<div class="row">
											<div class="col-6 halfWidthExact">										
												<mat-radio-group name="radioSchoolStatusList" id="radioSchoolStatus" 
													class="form-control" 
												aria-label="Select an option" >										
													<mat-radio-button *ngFor="let op2 of radioOptionsSchoolStatus" name="opList2FC"	
														ngDefaultControl																																	
														(click)="fnFigureRadioSchoolStatusChecked($event, op2.id)"	
														[formControl]="radioSchoolStatusFC"	
														[checked]="(op2.id == schoolStatus)"											
														value="{{op2.id}}"
														name="radioSchoolStatus"
														ngDefaultControl
														[(ngModel)]="schoolStatus"
														>{{op2.name}}&nbsp;&nbsp;
													</mat-radio-button><!-- value="1" [checked]="true"  tabindex="4" value="{{op2.id}}"  (op2.id == 1) || (op2.id == 2) || (op2.id == 3) [checked]="(op.id == schoolStatus)"-->
												<!--"(op2.id == schoolStatus)"        
													((op2.id == schoolStatus) && bCheckedSCCode1) || ((op2.id == schoolStatus) && bCheckedSCCode2) || ((op2.id == schoolStatus) && bCheckedSCCode3) 	"  -->
											</mat-radio-group>
											</div>
											<div class="col-4">
												<div class="raiseUpCloseDate form-group">
													<!--	bCancelEdit {{bCancelEdit}}										
														schoolStatus {{schoolStatus}} -->
													<span class="raiseUpCloseDateLabel">Close Date&nbsp;</span>			
													<mat-form-field class="schoolDatePicker" style="height:90px;" appearance="fill" color="accent">		
														<!--<mat-label>Close Date</mat-label> -->							
														<input matInput 
															formControlName="frmCloseDate" 
															[matDatepicker]="picker" 
															readonly
															(ngModelChange)="recheckClosedDate($event)"
															placeholder="{{closedDate? (closedDate!|simpleDate) : '' }}"
															[formControl]="newTestDateFC"
															(dateInput)="addEvent('input', $event)"
															(dateChange)="addEvent('change', $event)"
															style="transform:translateY(7px);"
															>																	
															<mat-datepicker #picker ></mat-datepicker>				
															<!--disabled <br>schoolStatus: {{schoolStatus}}  -->
														<!-- <div *ngIf="(schoolStatus == 2)">	 -->																							
															<span style="position:absolute;float:right;top:20px;right:0px;"><button class="noBordersBtn" (click)="openDialog()" style="background-color:transparent;"><mat-icon>calendar_today</mat-icon></button></span>                                                     
																<input matInput 																												
																readonly
																(ngModelChange)="recheckClosedDate($event)"
																formControlName="frmCloseDate"						
																>
														<!-- 	placeholder="{{closedDate? (closedDate!|simpleDate) : ''}}" </div> 												
														<div *ngIf="(schoolStatus != 2)">													
															<span style="position:absolute;float:right;top:20px;right:0px;"><button class="noBordersBtn raiseDown" disabled=true (click)="openDialog()"><mat-icon>calendar_today</mat-icon></button></span> 
															<span class="raiseUpSmall"><input matInput 													
																placeholder="{{closedDate? (closedDate!|simpleDate) : ''}}"
																readonly
																(ngModelChange)="recheckClosedDate($event)"
																formControlName="frmCloseDate"						
																></span>										
														</div>  -->
													</mat-form-field>	 
													<!-- <br><span class="errorMsgCtl">{{myCloseDateError}}</span>  -->
												</div>
											</div>									
										</div>
									</div>
								</mat-card-content>
							</mat-card>				
						</div>
					</div>

					<div class="child-2 col-6 halfWidth"> 
						<mat-card appearance="outlined" class="cardContactInfo">
							<mat-card-content>

								<h2>Contact Information</h2>
								<div class="form-group">
																
										<div class="row">
											<mat-label>Street 1 *</mat-label>
										</div>
										<div class="row">							
											<!-- 	[formControl]="txtStreet1FC"
													name="txtStreet1FC" [(ngModel)]="txtStreet1FC" -->				
											<mat-form-field  class="field-full-width" appearance="fill">
												<input id="txtStreet1" type="text" 
													(click)="btnClick2.emit($event)"
													name="txtStreet1FC"
													[formControl]="txtStreet1FC"
													[(ngModel)]="txtStreet1" 														
													ngDefaultControl															
													matInput>								
											</mat-form-field>
											<span class="raiseUpSmallErrorLabels">
												<mat-error *ngIf="selected.hasError('required')">Please enter a valid Street Name.
												</mat-error>
											</span>
										
										</div>										
										<div class="row">
											<mat-label>Street 2</mat-label>
										</div>
										<div class="row">
											<mat-form-field class="field-full-width" appearance="fill">
												<input id="txtStreet2" type="text" 
													(click)="btnClick2.emit($event)"
													[formControl]="txtStreet2FC"	
													name="txtStreet2FC"
													maxlength="100" 	
													ngDefaultControl
													[(ngModel)]="txtStreet2" 											
													matInput>										
											</mat-form-field>
											<span class="raiseUpSmallErrorLabels">
												<mat-error *ngIf="selected.hasError('required')">Please enter a valid Street Name.
												</mat-error>
											</span>
										
										</div>
										<div class="row">		
											<span class="col-9">																		
												<mat-label>City *</mat-label>
											</span>
											<span class="col-3 inchLeft">																		
												<mat-label>State</mat-label>
											</span>
										</div>
										<div class="row">
											<div class="row">
												<span class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9">													
													<!-- [formControl]="txtCityFC" [name]="txtCityFC"-->
													<input-city-autocomplete  style="width: 22vw"  
													[id]="'City'" [name]="'City'"
													[label]="'City'" [placeholder]="'City'" [(selectedCity)]="objCity"
													[(state)]="objState" [required]="true" 													
													ngDefaultControl
													[onlyCalifornia]="true"
													matInput
													#childCity></input-city-autocomplete>
												</span>
												<span class="col-xs-3 col-sm-3 col-md-3 col-lg-3col-xl-3">	
													<!-- [formControl]="txtStateFC" [name]="txtStateFC"-->
													<input-state-autocomplete 	 
												    [id]="'State'" [name]="'State'"
													[label]="'State'" [placeholder]="'State'" [(selectedState)]="objState"
													[required]="true" [disabledState]="true"													
													ngDefaultControl
													#childState
													></input-state-autocomplete>													
												</span>												
											</div>
										</div>										
										<div class="row">
											<span class="col-6">																		
											<mat-label>ZIP code *</mat-label>
											</span>																		
											<span class="col-5">																		
												<mat-label></mat-label>
												</span>			
										</div>
										<div class="row">
											<span class="child-2 col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5">	
												<input-zipcode-autocomplete [id]="'ZIP code'"
													[name]="'ZIP code'" [label]="'ZIP code'" [placeholder]="'ZIP code'"
													[(selectedZipcode)]="objZipcode" [required]="true" [countryId]="1"
													#childZip>
												</input-zipcode-autocomplete>
											</span>
											<span class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 moveRightSat"><!-- formControlName="chkSatelliteCampusFC"-->
												<mat-checkbox style="width:8vw" [color]="'primary'" 
													[formControl]="chkSatelliteCampusFC"											
													(change)="valueChkChange($event)"
													name="chkSatelliteCampusFC"
													ngDefaultControl
													[(ngModel)]="satelliteCampus" 
													>Satellite Campus</mat-checkbox>
											</span>
										</div>
										<br>																
									<div class="row">
										<mat-label>First Name</mat-label>
									</div>
									<div class="row">
										<mat-form-field class="field-full-width" appearance="fill">
											<input id="txtFirstName" type="text" 
												(click)="btnClick2.emit($event)"									
												[formControl]="txtFirstNameFC"		
												name="txtFirstName"
												maxlength="100" 
												(keydown)="onKeyDownNames"
												(keyup)="onKeyUpNames"
												ngDefaultControl
												[(ngModel)]="txtFirstName"								
												matInput>										
										</mat-form-field>
										<span class="raiseUpSmallErrorLabels">
											<mat-error *ngIf="selected.hasError('required')">Please enter a valid First Name.
											</mat-error>
										</span>
									
									</div>
									<div class="row">
										<mat-label>Last Name</mat-label>
									</div>
									<div class="row">
										<mat-form-field class="field-full-width" appearance="fill">
											<input id="txtLastName" type="text" 
												(click)="btnClick2.emit($event)"
												[formControl]="txtLastNameFC" 
												name="txtLastNameFC"
												maxlength="100" 
												(keydown)="onKeyDownNames"
												(keyup)="onKeyUpNames"
												ngDefaultControl
												[(ngModel)]="txtLastName"
												matInput>
										</mat-form-field>
										<span class="raiseUpSmallErrorLabels">
											<mat-error *ngIf="selected.hasError('required')">Please enter a valid Last Name.
											</mat-error>
										</span>
									</div>
									<div class="row">
										<mat-label>Phone Number</mat-label>
									</div>
									<div class="row">
										<mat-form-field class="field-full-width" appearance="fill">
											<input id="txtPhoneNumber" type="tel"
												(click)="btnClick2.emit($event)"
												[formControl]="txtPhoneNumberFC"
												name="txtPhoneNumberFC"
												maxlength="12" 
												ngDefaultControl	
												[(ngModel)]="txtPhoneNumber"
												matInput>
										</mat-form-field>
								
									<span class="raiseUpSmallErrorLabels">
										<mat-error *ngIf="selected.hasError('required')">Please enter a valid Phone Number.
										</mat-error>
									</span>
									</div>
									<div class="row">
										<mat-label>School's Email
											<help-text-btn class="align-help-text-btn" [helpTextId]="'SchoolEmail'"></help-text-btn>
										</mat-label>									
									</div>
									<div class="row">
										<input-email-standalone [form]="createSchoolsForm"
										[controlName]="emailObj"
										[name]="txtEmailFC"
										ngDefaultControl
										[formControl]="txtEmailFC"	
										 [matLabel]="'Work Email'"
										[placeholder]="'Work Email'"
										#emailChild
										(onValidatedEmailEvent)="validatedEmailEvent($event)"
										>
										</input-email-standalone>  						
									</div>
								</div>							
							</mat-card-content>
						</mat-card>
						<br>
						<mat-card appearance="outlined" class="cardGradeSpan">
							<mat-card-content>
								<h2>Grade Span</h2>
								<div class="form-group">
									<div class="row">
										<div class="col-6">
											<span class="raiseUpSmallGrade">Low Grade *</span>
											<mat-form-field appearance="fill">
												<mat-label>- Select Low Grade -</mat-label>
												<mat-select id="selectLowGrade" [(ngModel)]="gradeSpanLow" value="gradeSpanLow"		
													[formControl]="selectLowGradeFC"	
													name="selectLowGrade"
													ngDefaultControl
													(ngModelChange)="showValuePromptText('LowGradeItem', $event)"																			
													[errorStateMatcher]="matcher"	
													#childLowGrade											 											
													>											
													<mat-option *ngFor="let lowGradeItem of gradeItems"
														[value]="lowGradeItem?.ID">{{lowGradeItem.GRADES}}
														({{lowGradeItem?.DESCRIPTION}})</mat-option>
												</mat-select>
												<!--<mat-error *ngIf="selected.hasError('required')">You must make a selection
												</mat-error> -->
												<mat-error *ngIf="!validGrades">
													Low grade cannot be greater than high grade.
												</mat-error>
											</mat-form-field>
										</div>
										<div class="col-6">
											<span class="raiseUpSmallGrade">High Grade *</span>										
											<mat-form-field appearance="fill">
												<mat-label>- Select High Grade -</mat-label>
												<mat-select id="selectHighGrade" [(ngModel)]="gradeSpanHigh" value="gradeSpanHigh"												
													[formControl]="selectHighGradeFC"	
													name="selectHighGradeFC"
													ngDefaultControl
													(ngModelChange)="showValuePromptText('HighGradeItem', $event)"																					
													[errorStateMatcher]="matcher"													 											 
													#childHighGrade	
												>											 
													<mat-option *ngFor="let highGradeItems of gradeItems"
														[value]="highGradeItems?.ID">{{highGradeItems.GRADES}}
														({{highGradeItems?.DESCRIPTION}})</mat-option>
												</mat-select><!--	[formControl]="selected"-->
												<!-- <mat-error *ngIf="selected.hasError('required')">You must make a selection
												</mat-error> -->										
												<mat-error *ngIf="!validGrades">
													Low grade cannot be greater than high grade.
												</mat-error>
											</mat-form-field>
										</div>
										<span class="errorMsgCtl">{{myGradeError}}</span>
									</div>									
								</div>
							</mat-card-content>
						</mat-card>		
					</div>
				</div>		
		
				<br>
				<span style="padding-left:18px;">* Required fields</span>
				<div>
				<!--	<view-party-contact-mechanism *ngIf="(partyIdNum > 0)" [partyId]="partyIdNum"
						[enabledTypes]="['contactPersons','postalAddresses', 'emails','phoneNumbers']"
						[filterAddressTypes]="['Work Address']"
						[filterPhoneNumberTypes]="['Home Phone', 'Cell Phone', 'Work Phone', 'Other Phone']"
						[removeAddressTypes]="['Birthplace Address']"></view-party-contact-mechanism>
					<edit-party-contact-mechanism *ngIf="(partyIdNum > 0)" [partyId]="partyIdNum"
						[enabledTypes]="['contactPersons','postalAddresses', 'emails','phoneNumbers']"
						[filterAddressTypes]="['Current Address', 'Mailing Address']"
						[filterPhoneNumberTypes]="['Home Phone', 'Cell Phone', 'Work Phone', 'Other Phone']"
						[removeAddressTypes]="['Birthplace Address']"
						[type]="'Organization'"
						></edit-party-contact-mechanism>
					-->
				</div>
		<p>&nbsp;</p>
		<div class="row">

			<div class="errorMsg">
				<!--    class="col-8" rows="2"-->
				<hr>
				<span class="posRel" style="padding-left:18px;">
					<button
						mat-raised-button matTooltipschool="Edit record" 
						color="primary"
						(click)="fnSaveCreate()" class="btnRaise"
						[disabled]="disableCreateButton()"
						>
							<mat-icon class="iconDisplay">edit</mat-icon>
						&nbsp;Create <!-- {{createBtnText}} -->
					</button> &nbsp;&nbsp;<!--	>--> 
					<span class="moveResetButton">
						<span class="raiseResetButton">
						<button mat-raised-button (click)="fnReset()" color="warn">Reset</button>
						</span>
					</span>
					<!--
					<ng-container><button mat-raised-button matTooltip="Cancel create"
							class="btnRaise">{{createBtnText}}<mat-icon class="iconDisplay">close
							</mat-icon></button></ng-container>
					-->

						<!-- <ng-container>
							<button type="button" (click)="fnSaveCreate();" mat-raised-button color="primary"
								(onSubmitErrorEvent)="catchSubmitError($event)">Save</button>&nbsp;&nbsp;
						</ng-container> -->			
				</span>
				<!--<span>
					

					<mat-icon *ngIf="isLoading && !msg.SUCCESS"> 
						<mat-spinner *ngIf="isLoading" diameter="20"> </mat-spinner>
					</mat-icon> 
					<mat-icon *ngIf="msg.SUCCESS">
						done
					</mat-icon>
				</span>

				-->
				<textarea readonly="true" disabled class="errorMsgCtl" id="txtErrorMsg" cols="100">{{myError}}</textarea>
			</div>
			<div>
	<!--			<app-msg [msg]="userIdChangedMsg" *ngIf="userIdChangedMsg.MSG"></app-msg>
				<app-msg [msg]="msg"></app-msg> -->
			</div>
		</div>
	</div>
	<div *ngIf="isCreated" style="overflow:hidden;overflow-x:hidden;">
		<form>
			<mat-card-title><span style="padding-left:18px;font-size:larger;">Create New School</span></mat-card-title>
					<span class="floatRight" style="margin-right:30px;">
						<span class="forceHigh">
							<button class="close-button" mat-mini-fab [mat-dialog-close]="true" *ngIf="!isLoading">
								<mat-icon>close</mat-icon>
							</button>
						</span>
					</span>
					<div class="row">
						<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6col-xl-6" style="padding-left:20px;" >
						<mat-card appearance="outlined">
							<mat-card-content>
								<span class="greenBold">
									<h2>Successfully created new school</h2>
								</span>
								<p>&nbsp;</p>
								<button mat-raised-button matTooltip="Create new school" (click)="fnCreateAnother()"
									class="btnRaise">
									<ng-container *ngIf="!bCancelCreate">
										<mat-icon class="iconDisplay">edit</mat-icon>
									</ng-container>&nbsp;Create another school
								</button>
								<p>&nbsp;</p>
								<p>&nbsp;</p>				
							</mat-card-content>
						</mat-card>
					</div>
			</div> 
		</form>
	</div>
</form>
